import { Box, Button, Flex, GridItem, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import { motion } from 'framer-motion';
import { useColorModeValue } from '../../../components/ui/color-mode';
import { useTranslation } from 'react-i18next';

const MotionBox = motion.create(Box);
const MotionHeading = motion.create(Heading);
const MotionImage = motion.create(Image);
const MotionButton = motion.create(Button);


const OurNetwork = () => {

    let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13
    const cardColor = useColorModeValue('white', 'gray.900')
    //const textGhost = useColorModeValue('gray.800', 'gray.500')
    const {t} = useTranslation()

    return (
        <Box
            px={{'2xl': 16, base: 4 }}
            pt={24}
            pb={{'2xl': 40, md: 20, base: 0}}
            position={'relative'}
        >
            <Box
                //bgColor={cardColor}
                position={'relative'}
                overflow={'hidden'}
                px={{ md: '10%', '2xl': "19%", base: 4 }}
                py={40}
                bgGradient={'to-bl'}
                gradientFrom={useColorModeValue('blue.100', 'blue.800')}
                gradientTo={useColorModeValue('purple.200', 'purple.700')}
                boxShadow={'xl'} rounded={28} p={10} w={'full'} minH={'80vh'} display={'flex'} justifyContent={'start'} flexDir={'column'} alignItems={'center'}>

                <Flex 
                px={3} 
                rounded={'full'} 
                bgColor={cardColor}
                >
                    <Heading fontFamily={'Poppins'} fontSize={{'2xl': 'xl', base: 'md'}} letterSpacing={-1.2}>
                        {t('processSubtitle')}
                    </Heading>
                </Flex>


                <SimpleGrid mt={{'2xl': 40, base: 4}} gap={{'2xl': 10, base: 14}} columns={{md : 2, base: 1}}>
                    <GridItem>
                        <MotionHeading
                            mt={8}
                            textAlign={{'2xl': 'left', md: 'left', base: 'center'}}
                            fontFamily={'Onest'}
                            fontSize={{ '2xl': '8xl', md: '6xl', base: '4xl' }}
                            lineHeight={1}
                            letterSpacing={-0.8}
                            // initial={{ opacity: 0, y: 20 }}
                            // whileInView={{ opacity: 1, y: 0 }}
                            // transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                        > 
                        {t('processTitle')}
                        </MotionHeading>

                        <Flex w={'full'} justify={{'2xl': 'inherit', md: 'inherit', base: 'center'}}>

                            <MotionButton
                                mt={{'2xl':16, md: 10, base: 8}} py={6} size={{'2xl' :'xl', base: 'md'}} colorPalette={'purple'} variant={'surface'} fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium' : 'normal'} rounded={'full'}
                                // initial={{ opacity: 0, scale: 0.8 }}
                                // whileInView={{ opacity: 1, scale: 1 }}
                                // transition={{ duration: 0.5, delay: 0.2 }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                {t('processCallToAction')}
                            </MotionButton>
                        </Flex>
                    </GridItem>


                    <GridItem placeItems={'end'} justifyContent={'center'} display={'flex'} position={'relative'}>
                        <MotionBox
                            display={'flex'} justifyContent={'center'} alignItems={'center'} position={'relative'} rounded={'full'} 
                            boxSize={{'2xl' : '500px', md: '350px', base: '300px'}}
                            // initial={{ opacity: 0, scale: 0.8 }}
                            // whileInView={{ opacity: 1, scale: 1 }}
                            // transition={{ duration: 0.8 }}
                            // viewport={{ once: true }}
                        >
                            {/* Rotating Dashed Border */}
                            <MotionBox
                                position={'absolute'}
                                top={0} left={0} right={0} bottom={0}
                                rounded={'full'}
                                border={'1px dashed'}
                                borderColor={useColorModeValue('gray.500', 'gray.100')}
                                animate={{ rotate: 360 }}
                                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                            />
                            {/* Step 3: Left */}
                            <MotionBox left={{'2xl': -20, base: -9}} position={'absolute'}
                                initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ delay: 0.6, duration: 0.5 }} viewport={{ once: true }}
                            >
                                <Box overflow={'hidden'} display={'flex'} justifyContent={'center'} boxSize={{'2xl': 40, base: 20}} boxShadow={'xl'} rounded={'full'} bgColor={'white'}>
                                    <Image src={require('../../../assets/stepper/step3.png')} w={'160px'} />
                                </Box>
                                <Box position={'absolute'} left={'-80%'}>
                                    <Heading maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} lineHeight={1.1} fontFamily={'Poppins'} fontSize={'lg'} letterSpacing={-1.2}>{t('processStep1Title')}</Heading>
                                    <Text maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} mt={2} fontSize={'xs'} lineClamp={4}>
                                        {t('processStep1Description')}
                                    </Text>
                                </Box>
                            </MotionBox>

                            {/* Step 2: Top */}
                            <MotionBox top={{'2xl': -20, base: -9}} position={'absolute'}
                                initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.5 }} viewport={{ once: true }}
                            >
                                <Box overflow={'hidden'} display={'flex'} justifyContent={'center'} boxSize={{'2xl': 40, base: 20}} boxShadow={'xl'} rounded={'full'} bgColor={'white'}>
                                    <Image src={require('../../../assets/stepper/step2.png')} w={'160px'} />
                                </Box>

                                <Box position={'absolute'} top={'-30%'} right={'-120%'}>
                                    <Heading maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} lineHeight={1.1} fontFamily={'Poppins'} fontSize={'lg'} letterSpacing={-1.2}>{t('processStep2Title')}</Heading>
                                    <Text maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} mt={2} fontSize={'xs'} lineClamp={4}>
                                        {t('processStep2Description')}
                                    </Text>
                                </Box>
                            </MotionBox>


                            {/* Step 1: Right */}
                            <MotionBox display={'flex'} right={{'2xl': -20, base: -9}} position={'absolute'}
                                initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ delay: 0.2, duration: 0.5 }} viewport={{ once: true }}
                            >
                                <Box overflow={'hidden'} display={'flex'} justifyContent={'center'} boxSize={{'2xl': 40, base: 20}} boxShadow={'xl'} rounded={'full'} bgColor={'white'}>
                                    <Image src={require('../../../assets/stepper/step1.png')} w={'160px'} />
                                </Box>

                                <Box position={'absolute'} right={'-120%'}>
                                    <Heading maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} lineHeight={1.1} fontFamily={'Poppins'} fontSize={'lg'} letterSpacing={-1.2}>{t('processStep3Title')}</Heading>
                                    <Text maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} mt={2} fontSize={'xs'} lineClamp={4}>
                                        {t('processStep3Description')}
                                    </Text>
                                </Box>
                            </MotionBox>

                            {/* Step 4: Bottom */}
                            <MotionBox bottom={{'2xl': -20, base: -9}} position={'absolute'} display={'flex'}
                                initial={{ opacity: 0, y: -50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.8, duration: 0.5 }} viewport={{ once: true }}
                            >
                                <Box overflow={'hidden'} display={'flex'} justifyContent={'center'} boxSize={{'2xl': 40, base: 20}} boxShadow={'xl'} rounded={'full'} bgColor={'white'}>
                                    <Image src={require('../../../assets/stepper/step4.png')} w={'160px'} />
                                </Box>

                                <Box position={'absolute'} right={'-120%'} top={'60%'}>
                                    <Heading maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} lineHeight={1.1} fontFamily={'Poppins'} fontSize={'lg'} letterSpacing={-1.2}>{t('processStep4Title')}</Heading>
                                    <Text maxW={'150px'} visibility={{ '2xl': 'visible', base: 'hidden'}} mt={2} fontSize={'xs'} lineClamp={4}>
                                        {t('processStep4Description')}
                                    </Text>
                                </Box>
                            </MotionBox>

                            <MotionBox textAlign={'center'} maxW={'200px'}
                                // initial={{ scale: 0 }}
                                // whileInView={{ scale: 1 }}
                                // animate={{ scale: [1, 1.05, 1] }}
                                // transition={{
                                //     scale: { duration: 2, repeat: Infinity, ease: "easeInOut" },
                                //     default: { delay: 1, type: "spring", stiffness: 200, damping: 10 }
                                // }}
                                viewport={{ once: true }}
                            >
                                <Heading py={4}
                                    bgGradient={'to-r'}
                                    gradientFrom={'blue.500'}
                                    gradientTo={'purple.600'}
                                    bgClip={'text'}
                                    fontFamily={'Onest'}
                                    fontSize={'7xl'}>
                                    48
                                </Heading>
                                <Heading fontFamily={'Poppins'} fontSize={{'2xl': 'lg', base: 'md'}} letterSpacing={-1.1} >{t('processMainText')}</Heading>
                            </MotionBox>
                        </MotionBox>
                    </GridItem>
                </SimpleGrid>




                <MotionImage
                    w={{ '2xl': '400px', md: '250px', base: '130px'}} opacity={useColorModeValue(0.5, 'none')} rotate={'35deg'} bottom={{'2xl' : 0, md: -20, base: -10}} position={'absolute'} left={{'2xl' : 0, md: -20, base: -10}} src={require('../../../assets/vector/4.png')}
                    // initial={{ opacity: 0, x: -50 }}
                    // whileInView={{ opacity: useColorModeValue(0.5, 1), x: 0 }}
                    // animate={{ y: [0, -20, 0] }}
                    // transition={{
                    //     duration: 1,
                    //     y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
                    // }}
                />

            </Box>


        </Box>
    )
}

export default OurNetwork